import React, { useContext } from "react";
import { AuthContext } from "../../store/auth-context";

const Navigation = (props) => {
  const classes = props.className;
  const authCtx = useContext(AuthContext);

  return (
    <nav className={classes}>
      <ul>
        <li>Users</li>
        <li>Admin</li>
        <li onClick={authCtx.onLogout}>Logout</li>
      </ul>
    </nav>
  );
};

export default React.memo(Navigation);
